import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { ReportsTreinamentosForm } from "../../../schemas/Funcionarios_lista/reports_treinamentos";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { FuncionarioNomeDropDown } from "../../../../domain/models/funcionario_nome_dropdown";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import { FormRangeDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_range_picker_input";
import { TreinamentoDropDown } from "../../../../domain/models/treinamento_dropdown";

import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { CargoDropDown } from "../../../../../../common/domain/models/cargo_dropdown";

/**
 * ReportsTreinamentos
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  funcionarioNomesLista: FuncionarioNomeDropDown[];
  centroCustoLista: CentroCustoDropDown[];
  treinamentosDropdown: TreinamentoDropDown[];
  cargosDropdown: CargoDropDown[];
  onClose: () => void;
  onSubmit: (form: ReportsTreinamentosForm) => void;
};

export const ReportsTreinamentos = ({
  open,
  saving,
  loading,
  funcionarioNomesLista,
  centroCustoLista,
  treinamentosDropdown,
  cargosDropdown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ReportsTreinamentosForm>({});

  useEffect(() => {
    if (open) hookForm.reset();
  }, [hookForm, open]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(onSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "80rem",
          },
        },
      }}>
      <DialogTitle>
        Relatório Treinamentos
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={loading || saving}>
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>
              <DefaultFormMultiAutocomplete
                name='nome'
                label='Nome'
                options={funcionarioNomesLista}
                getOptionKey={x => x.idFuncionario}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm}
              />

              <DefaultFormMultiAutocomplete
                name='cargos'
                label='Cargo'
                options={cargosDropdown}
                getOptionKey={(x) => x.idCargo}
                getOptionLabel={(x) => x.descricao ?? ""}
                reactHookForm={hookForm}
              />

              <DefaultFormMultiAutocomplete
                name='status'
                label='Status'
                options={[{ id: 0, nome: 'Ativos' }, { id: 1, nome: 'Demitidos' }]}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm}
              />

              <DefaultFormMultiAutocomplete
                name='treinamentos'
                label='Treinamento'
                options={treinamentosDropdown}
                getOptionKey={(x) => x.idTreinamento}
                getOptionLabel={(x) => x.descricao}
                reactHookForm={hookForm}
              />

              <FormRangeDatePickerInput
                label='Data Treinamento'
                name='dataTreinamento'
                reactHookForm={hookForm}
              />

              <DefaultFormMultiAutocomplete
                name='centroCusto'
                label='Centro de Custo'
                options={centroCustoLista}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.title}
                reactHookForm={hookForm}
              />

              <DefaultFormMultiAutocomplete
                name='eficaz'
                label='Eficaz'
                options={[{ id: 0, nome: 'Sim' }, { id: 1, nome: 'Não' }]}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm}
              />



            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              <PrimaryButton
                type="submit"
                buttonColor="primary-green">
                Gerar
              </PrimaryButton>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}